import React from 'react'

const Pagination = ({ page, total, limit: lim, navigate }) => {
    if (total <= lim)
        return null
        
    const paginate = () => {
        let pages = Math.ceil(total / lim)

        let limit = 10
        let start = 1
        let list = []
        let i = Math.min(pages + start - limit, Math.max(start, page - (limit / 2 | 0)))
        let end = i + limit
        if (i < 1) {
            i = 1
        }

        while (i < end) {
            list.push(i++)
        }

        return list
    }

    return (
        <section className="w-10/12 mx-auto my-3">
            <ul className="flex justify-center pl-0 list-none my-2">
                <li onClick={() => navigate(1)} className="relative block mr-2.5 py-2 px-3 cursor-pointer leading-tight rounded-xl hover:bg-gray-200">
                    <p className="page-link my-0"><i className="fas fa-arrow-left" /></p>
                </li>
                {
                    paginate().map((i, k) =>
                        <li key={k} onClick={() => navigate(i)} className={`relative page-list ${Number(page) === Number(i) ? 'bg-gray-200' : ''} block mr-2.5 cursor-pointer py-2 px-3 rounded-xl leading-tight hover:bg-gray-200`}>
                            <p className="page-link my-0">{i}</p>
                        </li>
                    )
                }
                <li onClick={() => navigate(Math.ceil(total / lim))} className="relative block mr-2.5 py-2 px-3 cursor-pointer leading-tight rounded-xl hover:bg-gray-200">
                    <p className="page-link my-0"><i className="fas fa-arrow-right" /></p>
                </li>
            </ul>
        </section>
    )
}

export default Pagination